import React from 'react'
import PVTimesheetbyStaff from '../PartialView/PV_TimesheetbyStaff'
import { Helmet } from "react-helmet";

/*
Edit BY Krisana : 30-05-2024
      - เพิ่ม Pro_name เพราะเนื่องจาก PVTimesheetbyStaff มีการส่งค่า ชื่อ Project เพื่อนำไปออกบน Report ในกรณีที่ดูข้อมูล ByStaff
*/
function Report_sumByTimeSheetByStaff() {
  return (
    <>
    
        <Helmet>
            <title>Timesheet report</title>
        </Helmet>
        <div className="content-wrapper">
         {/* 
          <div className="content-header">
            <div className="row text-center ">
              <div className="col-md-10 offset-md-1 ">
                <div className="container-fluid">
                  <h1 className=" display-5"> Report 7</h1>
                  <h6>Timesheet By Staff report</h6>
                </div>



                
              </div>
            </div>
          </div>*/}
          <PVTimesheetbyStaff
            isReport={1}
            Pro_id={"-1"}
            Pro_name={""}
          >
          </PVTimesheetbyStaff>
        </div>
    </>
  )
}

export default Report_sumByTimeSheetByStaff